module.exports = __webpack_public_path__ + "static/media/amusement(16).0c2f20d6.PNG";